export default "__VITE_ASSET__DcZSUhf9__"